import { Box, Skeleton } from "@luce/ui";

export function GiftDetailSkeleton() {
  return (
    <Box className="gap-spacing-lg p-spacing-lg flex flex-col">
      <Skeleton radius="lg" className="aspect-[114/64] w-full" />
      {[0, 1, 2, 3].map((row) => (
        <Box key={row} className="gap-spacing-xs flex flex-col">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-5 w-40" />
        </Box>
      ))}
    </Box>
  );
}
